import Marionette from "backbone.marionette";
import templates from "../../../../../../utils/templates";

const DEFAULTS = {
  template: templates.find("masthead", "avatar_dropdown_title"),
};

class Title extends Marionette.ItemView {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }
}

export { Title as default };
